// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.price-text {
  display: flex;
  justify-content: right;
}

.grid-gutter-spacing {
  grid-row-gap: 5px !important;
}

.text-field-address {
  display: block;
}

.list-styles {
  background-color: var(--fds-color--white);
  list-style: none;
  z-index: 99;
  position: absolute;
  margin-top: -6px !important;
  width: 53%;
  max-width: 765px;
}

.hide-address-suggest {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s 0.2s, opacity 0.2s ease-out;
}

#error-banner {
  background-color: #d62d0a;
  text-align: center;
  padding: 1em;
  font-size: 1.6rem;
  font-weight: 500;
  font-family: inherit;
  width: 100%;
  letter-spacing: normal;
}

.top-margin {
  margin-top: 2px;
}

@media screen and (max-width: 1439px) {
  .list-styles {
    width: 43%;
  }
}
@media screen and (max-width: 1023px) {
  .contact-info-column {
    order: 2;
  }
  .product-info-column {
    order: 1;
  }
  .list-styles {
    width: 58%;
    max-width: 445px;
  }
}
@media screen and (max-width: 599px) {
  .list-styles {
    width: 78%;
    max-width: 330px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CustomerInfoForm/CustomerInfoForm.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,yCAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,2BAAA;EACA,UAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,qDACE;AAAJ;;AAIA;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;EACA,sBAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE;IACE,UAAA;EADF;AACF;AAIA;EACE;IACE,QAAA;EAFF;EAKA;IACE,QAAA;EAHF;EAMA;IACE,UAAA;IACA,gBAAA;EAJF;AACF;AAOA;EACE;IACE,UAAA;IACA,gBAAA;EALF;AACF","sourcesContent":[".price-text {\n  display: flex;\n  justify-content: right;\n}\n\n.grid-gutter-spacing {\n  grid-row-gap: 5px !important;\n}\n\n.text-field-address {\n  display: block;\n}\n\n.list-styles {\n  background-color: var(--fds-color--white);\n  list-style: none;\n  z-index: 99;\n  position: absolute;\n  margin-top: -6px !important;\n  width: 53%;\n  max-width: 765px;\n}\n\n.hide-address-suggest {\n  visibility: hidden;\n  opacity: 0;\n  transition:\n    visibility 0s 0.2s,\n    opacity 0.2s ease-out;\n}\n\n#error-banner {\n  background-color: #d62d0a;\n  text-align: center;\n  padding: 1em;\n  font-size: 1.6rem;\n  font-weight: 500;\n  font-family: inherit;\n  width: 100%;\n  letter-spacing: normal;\n}\n\n.top-margin {\n  margin-top: 2px;\n}\n\n@media screen and (max-width: 1439px) {\n  .list-styles {\n    width: 43%;\n  }\n}\n\n@media screen and (max-width: 1023px) {\n  .contact-info-column {\n    order: 2;\n  }\n\n  .product-info-column {\n    order: 1;\n  }\n\n  .list-styles {\n    width: 58%;\n    max-width: 445px;\n  }\n}\n\n@media screen and (max-width: 599px) {\n  .list-styles {\n    width: 78%;\n    max-width: 330px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
